import { render, staticRenderFns } from "./BandejaEmbajadorComponente.vue?vue&type=template&id=5541fe86"
import script from "./BandejaEmbajadorComponente.vue?vue&type=script&lang=js"
export * from "./BandejaEmbajadorComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports